import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(public)/response/$id')({
  component: ResponsePage,
});

function ResponsePage() {
  return <div>TODO: Form Response</div>;
}
